// Document view/print — logs a reason (Doc/Print), then the caller opens the
// PDF URL in a new tab. The PDF endpoints are GET navigations (session cookie,
// no CSRF), so they're plain URLs rather than fetch calls.

import { postJson } from './http';
import type { SaveResult } from '@/types/api';

const API = '/api/V1';

export const docRealApi = {
  /** Log a view/print reason (ports ajax/doc-print.php → `reprint`). */
  printDoc(docId: number, docType: string, docAdd: number, message: string): Promise<SaveResult> {
    return postJson<SaveResult>(`${API}/Doc/Print`, { docId, docType, docAdd, message });
  },
};

/** URL builders for the inline-PDF GET endpoints (used with window.open). */
export const pdfUrls = {
  cpl: (id: number) => `${API}/Cpl/Pdf?id=${encodeURIComponent(String(id))}`,
  jacket: (id: number, isAdd = false) =>
    `${API}/Jacket/Pdf?id=${isAdd ? 'A' : ''}${encodeURIComponent(String(id))}`,
  /** Remittance Report PDF for a date range. Admins may pass agent (user id) / org. */
  remit: (from: string, to: string, agent?: number, org?: number) => {
    const q = new URLSearchParams({ s: from, t: to });
    if (agent != null) q.set('a', String(agent));
    if (org != null) q.set('o', String(org));
    return `${API}/Report/Remit?${q.toString()}`;
  },
};
